import { api, Api } from '@/services/api';
import type { Advertisments, AdvertismentsParams, Country, ListResult } from '@/types';

/**
 * Misc endpoints — countries, ws-token (Centrifugo handshake), advertisements.
 * Mobile's `setFcmToken` mutation is dropped (FCM not applicable in Telegram
 * WebView). Notification list/read endpoints are dropped — Bot push will
 * arrive via Telegram itself in a later phase.
 */
const miscEndpoints = api.injectEndpoints({
  endpoints: (builder) => ({
    wsToken: builder.query<{ token: string }, string>({
      query: (id) => ({ url: Api.WsToken.replace(':id', id) }),
      providesTags: ['Users'],
    }),
    countries: builder.query<ListResult<Country>, { search: string }>({
      query: (params) => ({
        url: Api.Countries,
        params,
      }),
    }),
    advertisements: builder.query<ListResult<Advertisments>, AdvertismentsParams>({
      query: (params) => ({
        url: Api.Advertisements,
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const {
  useWsTokenQuery,
  useLazyWsTokenQuery,
  useCountriesQuery,
  useLazyCountriesQuery,
  useAdvertisementsQuery,
} = miscEndpoints;
